'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/ai-learning',
        name: 'ai-learning',
        meta: {
            title: 'AI learning inbox',
            scopes: ['read_ai_conversations'],
        },
        component: () => view('ai-learning/index'),
    },
];
